export default __webpack_public_path__ + "static/media/check.f158059e.svg";